<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" color="primary">
      <v-icon>
        mdi-card-text-outline
      </v-icon>
      New Self-Schedule Invite
    </SecondaryButton>
    <SelfScheduleInviteDialog
      @close="closeDialog"
      :isOpen="isOpen"
      v-if="isOpen"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import SelfScheduleInviteDialog from "@/views/bookings/BookingInterviews/components/dialogs/SelfScheduleInvites/SelfScheduleInvite/SelfScheduleInviteDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "SelfScheduleInviteAction",
  components: {
    SelfScheduleInviteDialog,
    SecondaryButton,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
